<template>
  <div class="sticky">
    <div
      class="vx-navbar-wrapper"
      :style="
        $store.state.AppActiveUser.userType === 'dermaSpecialist'
          ? ''
          : 'width: 100%;'
      "
      :class="classObj"
    >
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />
        <ClinicSetupBankDetail />
        <vs-spacer />
        <cart-drop-down v-if="showCart" />
        <clinic-profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import CartDropDown from '../components/clinic/ClinicCartDropDown.vue';
import ClinicProfileDropDown from '../components/clinic/ClinicProfileDropDown.vue';
import ClinicSetupBankDetail from '../components/clinic/ClinicSetupBankDetail.vue';
import { mapActions } from 'vuex';

export default {
  name: 'TheDoctorClinicNavbarVertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  data: () => ({
    clinicCompanyName: '',
    showCart: false,
  }),
  components: {
    CartDropDown,
    ClinicProfileDropDown,
    ClinicSetupBankDetail,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff'
        ? '#10163a'
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        'text-white':
          (this.navbarColor != '#10163a' &&
            this.$store.state.theme === 'dark') ||
          (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark'),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    // eslint-disable-next-line vue/return-in-computed-property
    classObj() {
      if (this.verticalNavMenuWidth == 'default') return 'navbar-default';
      else if (this.verticalNavMenuWidth == 'reduced') return 'navbar-reduced';
      else if (this.verticalNavMenuWidth) return 'navbar-full';
    },
  },
  beforeMount: async function () {
    await this.fetchAppUserIndex();
  },
  methods: {
    ...mapActions('appUser', ['fetchAppUserIndex']),
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
  watch: {
    'this.$store.state.AppActiveUser.clinicName': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.clinicCompanyName = this.$store.state.AppActiveUser.clinicName;
      }
    },
  },
  created() {
    this.clinicCompanyName = this.$store.state.AppActiveUser.clinicName;

    if (this.$store.state.AppActiveUser.userType === 'subClinic') {
      this.$store
        .dispatch(
          'clinic/fetchClinicsDetail',
          this.$store.state.AppActiveUser.parentClinicId
        )
        .then((res) => {
          this.clinicCompanyName = res.data.data.clinicName;
        });
    }
  },
};
</script>
